/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdContactsLabels200Ok
 */
export interface GetCharactersCharacterIdContactsLabels200Ok {
    /**
     * label_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdContactsLabels200Ok
     */
    labelId: number;
    /**
     * label_name string
     * @type {string}
     * @memberof GetCharactersCharacterIdContactsLabels200Ok
     */
    labelName: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdContactsLabels200Ok interface.
 */
export function instanceOfGetCharactersCharacterIdContactsLabels200Ok(value: object): value is GetCharactersCharacterIdContactsLabels200Ok {
    if (!('labelId' in value) || value['labelId'] === undefined) return false;
    if (!('labelName' in value) || value['labelName'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdContactsLabels200OkFromJSON(json: any): GetCharactersCharacterIdContactsLabels200Ok {
    return GetCharactersCharacterIdContactsLabels200OkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdContactsLabels200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdContactsLabels200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'labelId': json['label_id'],
        'labelName': json['label_name'],
    };
}

export function GetCharactersCharacterIdContactsLabels200OkToJSON(json: any): GetCharactersCharacterIdContactsLabels200Ok {
    return GetCharactersCharacterIdContactsLabels200OkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdContactsLabels200OkToJSONTyped(value?: GetCharactersCharacterIdContactsLabels200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label_id': value['labelId'],
        'label_name': value['labelName'],
    };
}

